import { render, staticRenderFns } from "./WorkshopAzienda.vue?vue&type=template&id=3a343a30&scoped=true&"
import script from "./WorkshopAzienda.vue?vue&type=script&lang=ts&"
export * from "./WorkshopAzienda.vue?vue&type=script&lang=ts&"
import style0 from "./WorkshopAzienda.vue?vue&type=style&index=0&id=3a343a30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a343a30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VDivider,VIcon,VRow})
